import { flow, observable } from "mobx";
import { awaitableWhen } from "../../utils/util";
import { BackendResponse } from "../BackendResponse";
import { NextApiParams, withNextApi } from "../nextApiHelpers";

export interface UpdateCandidateResponse extends BackendResponse {}

export interface UpdateCandidateParameters extends NextApiParams {
  fields: UpdateField[];
}

export type updateCandidate = (
  args: UpdateCandidateParameters
) => Promise<UpdateCandidateResponse>;

const _updateCandidate = withNextApi<
  UpdateCandidateResponse,
  UpdateCandidateParameters
>("/cvp/CvpUpdateCandidate", {
  f: async (args, f) => {
    let data = await f(args);

    if (data?.message) data.ok = false;
    if (data?.message)
      data.message = `Unable to update fields: ${data.message}`;

    return data;
  },
});

const queue = observable.array();

// wait until previous updateCandidate is done before starting a new one
export const updateCandidate: typeof _updateCandidate = flow(function* (args) {
  const f = () => _updateCandidate(args);
  queue.push(f);

  let result;
  try {
    yield awaitableWhen(() => queue[0] === f);

    result = yield f();
  } finally {
    queue.remove(f);
  }

  return result;
});

export interface UpdateField {
  fieldName: string;
  fieldValue: string | null;
}
